<template>
  <Authenticate>
    <VuelidateRegister />
  </Authenticate>
</template>

<script>
import Authenticate from "@/components/authenticate/Authenticate";
import VuelidateRegister from "@/components/authenticate/VuelidateRegister";

export default {
  components: {
    Authenticate,
    VuelidateRegister
  }
};
</script>
